import organizationDetail from './organizationDetail.vue'
export default organizationDetail
